<div class="radio">
  <input
    class="radio__input"
    type="radio"
    [id]="id"
    [name]="name"
    [value]="value"
    [checked]="checked"
    [disabled]="disabled"
    (change)="onChange($event)"
  />
  <label class="radio__label" [for]="id">{{ label }}</label>
</div>
